/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoRaffleUpsertRequest model module.
 * @module model/EventsControllerDtoRaffleUpsertRequest
 * @version 1.0
 */
class EventsControllerDtoRaffleUpsertRequest {
    /**
     * Constructs a new <code>EventsControllerDtoRaffleUpsertRequest</code>.
     * @alias module:model/EventsControllerDtoRaffleUpsertRequest
     */
    constructor() { 
        
        EventsControllerDtoRaffleUpsertRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoRaffleUpsertRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoRaffleUpsertRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoRaffleUpsertRequest} The populated <code>EventsControllerDtoRaffleUpsertRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoRaffleUpsertRequest();

            if (data.hasOwnProperty('raffleNo')) {
                obj['raffleNo'] = ApiClient.convertToType(data['raffleNo'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('itemDrawStartAt')) {
                obj['itemDrawStartAt'] = ApiClient.convertToType(data['itemDrawStartAt'], 'Date');
            }
            if (data.hasOwnProperty('itemDrawEndAt')) {
                obj['itemDrawEndAt'] = ApiClient.convertToType(data['itemDrawEndAt'], 'Date');
            }
            if (data.hasOwnProperty('ticketRequiredCount')) {
                obj['ticketRequiredCount'] = ApiClient.convertToType(data['ticketRequiredCount'], 'Number');
            }
            if (data.hasOwnProperty('ticketItems')) {
                obj['ticketItems'] = ApiClient.convertToType(data['ticketItems'], 'String');
            }
            if (data.hasOwnProperty('jsonRoundInfo')) {
                obj['jsonRoundInfo'] = ApiClient.convertToType(data['jsonRoundInfo'], 'String');
            }
            if (data.hasOwnProperty('jsonRewardInfo')) {
                obj['jsonRewardInfo'] = ApiClient.convertToType(data['jsonRewardInfo'], 'String');
            }
            if (data.hasOwnProperty('jsonBonusReward')) {
                obj['jsonBonusReward'] = ApiClient.convertToType(data['jsonBonusReward'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoRaffleUpsertRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoRaffleUpsertRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['ticketItems'] && !(typeof data['ticketItems'] === 'string' || data['ticketItems'] instanceof String)) {
            throw new Error("Expected the field `ticketItems` to be a primitive type in the JSON string but got " + data['ticketItems']);
        }
        // ensure the json data is a string
        if (data['jsonRoundInfo'] && !(typeof data['jsonRoundInfo'] === 'string' || data['jsonRoundInfo'] instanceof String)) {
            throw new Error("Expected the field `jsonRoundInfo` to be a primitive type in the JSON string but got " + data['jsonRoundInfo']);
        }
        // ensure the json data is a string
        if (data['jsonRewardInfo'] && !(typeof data['jsonRewardInfo'] === 'string' || data['jsonRewardInfo'] instanceof String)) {
            throw new Error("Expected the field `jsonRewardInfo` to be a primitive type in the JSON string but got " + data['jsonRewardInfo']);
        }
        // ensure the json data is a string
        if (data['jsonBonusReward'] && !(typeof data['jsonBonusReward'] === 'string' || data['jsonBonusReward'] instanceof String)) {
            throw new Error("Expected the field `jsonBonusReward` to be a primitive type in the JSON string but got " + data['jsonBonusReward']);
        }

        return true;
    }


}



/**
 * @member {Number} raffleNo
 */
EventsControllerDtoRaffleUpsertRequest.prototype['raffleNo'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoRaffleUpsertRequest.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoRaffleUpsertRequest.prototype['endAt'] = undefined;

/**
 * @member {Date} itemDrawStartAt
 */
EventsControllerDtoRaffleUpsertRequest.prototype['itemDrawStartAt'] = undefined;

/**
 * @member {Date} itemDrawEndAt
 */
EventsControllerDtoRaffleUpsertRequest.prototype['itemDrawEndAt'] = undefined;

/**
 * @member {Number} ticketRequiredCount
 */
EventsControllerDtoRaffleUpsertRequest.prototype['ticketRequiredCount'] = undefined;

/**
 * @member {String} ticketItems
 */
EventsControllerDtoRaffleUpsertRequest.prototype['ticketItems'] = undefined;

/**
 * @member {String} jsonRoundInfo
 */
EventsControllerDtoRaffleUpsertRequest.prototype['jsonRoundInfo'] = undefined;

/**
 * @member {String} jsonRewardInfo
 */
EventsControllerDtoRaffleUpsertRequest.prototype['jsonRewardInfo'] = undefined;

/**
 * @member {String} jsonBonusReward
 */
EventsControllerDtoRaffleUpsertRequest.prototype['jsonBonusReward'] = undefined;






export default EventsControllerDtoRaffleUpsertRequest;

